<script setup>
import ServiceItem from "@/views/home/ServiceItem.vue";
import {defineProps} from "vue";
const props = defineProps({
  serviceItemList: {type: Array, default: () => []},
});
console.log("service item list")
console.log(props.serviceItemList);
</script>

<template>
  <!-- SERVICES LIST & BOOKING FORM -->
  <div class="impx-content impx-services style2 bg-color-csa pattern-1">
    <div class="uk-container">

      <div class="uk-margin-medium-bottom impx-margin-bottom-small" data-uk-grid>

        <!-- Services List -->
        <div class="uk-width-expand impx-services-list uk-margin-bottom impx-margin-bottom-small">
          <h6 class="uk-heading-line uk-text-center uk-light  uk-text-large uk-margin-bottom impx-text-white"><span>Nos Services</span>
          </h6>
          <div
              class="uk-child-width-1-4@xl uk-child-width-1-4@l uk-child-width-1-4@m uk-child-width-1-2@s uk-grid-medium"
              data-uk-grid>
            <service-item
                v-for="(service, index) in props.serviceItemList"
                :key="index"
                :service-title="service.title"
                :service-img="service?.serviceImage?.url"
                :service-link="service?.serviceAction?.link??'/'"
                :service-desc="service.subtitle"
                :service-action-title="service?.serviceAction?.title??'Voir plus'"
            ></service-item>
          </div>
        </div>
        <!-- Services List End -->

      </div>
    </div>
  </div>
  <!-- SERVICES LIST & BOOKING FORM END -->
</template>

<style scoped>

</style>